import type { MouseEvent, ReactNode } from "react";
import usePortal from "react-cool-portal";
import clsx from "clsx";
import { PreventScroll } from "@/components/PreventScroll";

type Props = {
  open: boolean;
  onClose: (event: MouseEvent) => void;
  children: ReactNode;
};
export const Drawer = ({ open, onClose, children }: Props) => {
  const { Portal } = usePortal({
    clickOutsideToHide: false,
    defaultShow: true,
    internalShowHide: false,
  });

  return (
    <Portal>
      <div
        className={clsx("fixed inset-0 z-30 bg-primary/50", {
          hidden: !open,
        })}
        onClick={onClose}
      />
      <div
        className={clsx(
          "fixed top-0 bottom-0 right-0 overflow-y-auto z-40 transition-transform cursor-default bg-white w-full md:w-[768px]",
          {
            "translate-x-full": !open,
            "md:drop-shadow-sm md:shadow-sm": open,
          },
        )}
      >
        {open && children}
      </div>
      {open && <PreventScroll />}
    </Portal>
  );
};
